import React, { useCallback, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useFormik } from 'formik'

import Form from '../../../../../components/Form'
import AdServerFormFields from '../AdServerFormFields'

import { selectedPartnershipRightsHolderIdSelector } from '../../../../../modules/selectors/partnerships'
import {
  updateAdServerErrorSelector,
  updateAdServerIsLoadingSelector,
  updateAdServerWasUpdatedSelector
} from '../../../../../modules/selectors/adServer'
import { clearUpdateAdServer, updateAdServer } from '../../../../../modules/actions/adServer'

import { AD_SERVER_ACCESS_UPDATE } from '../../../../../constants/forms'
import { AD_SERVER_TYPE, API_KEY, validationSchema } from '../reusableFields'

import { getInitialValues } from './fields'

function AdServerAccessUpdateForm({ rightHolderAdServer }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const adServerWasUpdated = useSelector(updateAdServerWasUpdatedSelector)

  const selectedPartnershipRightsHolderId = useSelector(selectedPartnershipRightsHolderIdSelector)

  const onSubmit = useCallback(
    values => {
      dispatch(
        updateAdServer({
          [API_KEY]: values[API_KEY],
          [AD_SERVER_TYPE]: values[AD_SERVER_TYPE],
          account: selectedPartnershipRightsHolderId,
          id: rightHolderAdServer.id
        })
      )
    },
    [dispatch, selectedPartnershipRightsHolderId, rightHolderAdServer]
  )

  const initialValues = useMemo(() => {
    return getInitialValues(rightHolderAdServer)
  }, [rightHolderAdServer])

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit
  })

  useEffect(() => {
    if (adServerWasUpdated) {
      dispatch(clearUpdateAdServer())
    }
  }, [dispatch, adServerWasUpdated])

  return (
    <Form
      formik={formik}
      method="post"
      formName={AD_SERVER_ACCESS_UPDATE}
      successSubmit={adServerWasUpdated}
      errorSelector={updateAdServerErrorSelector}
      isLoadingSelector={updateAdServerIsLoadingSelector}
      submitText={t('Save')}
    >
      <AdServerFormFields formik={formik} />
    </Form>
  )
}

AdServerAccessUpdateForm.propTypes = {
  rightHolderAdServer: PropTypes.shape({
    [AD_SERVER_TYPE]: PropTypes.string.isRequired,
    [API_KEY]: PropTypes.string.isRequired
  })
}

export default AdServerAccessUpdateForm
